import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import makeEditable from '../../../shared/functionality/makeEditable';
import componentForItem from '../../../../util/componentForItem';
import { COMPONENT_SHOW } from '@instructure/quiz-common';
import { propsForInteractionShow } from '../../../../util/interactionTypePropsHelper';
var ItemShow = /*#__PURE__*/function (_Component) {
  function ItemShow() {
    _classCallCheck(this, ItemShow);
    return _callSuper(this, ItemShow, arguments);
  }
  _inherits(ItemShow, _Component);
  return _createClass(ItemShow, [{
    key: "render",
    value: function render() {
      var item = this.props.entry;
      var Interaction = componentForItem(item.getInteractionType().slug, COMPONENT_SHOW);
      var propsForInteraction = propsForInteractionShow(item.toJS());
      return /*#__PURE__*/React.createElement(Interaction, Object.assign({}, propsForInteraction, {
        itemId: this.props.guid,
        switchOnEditing: this.props.switchOnEditing
      }));
    }
  }]);
}(Component);
_defineProperty(ItemShow, "propTypes", {
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  switchOnEditing: PropTypes.func
});
_defineProperty(ItemShow, "defaultProps", {
  switchOnEditing: null
});
export default makeEditable(ItemShow);